import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IconComponent } from '@pc/icon';
import { ChevronState } from '../quote-overview.const';
import { ItemsSummaryCardAnimation } from '@pc/items-summary-card';
import { expand } from '@pc/animations';
import { SeparatorComponent } from '@pc/separator';
import { DialogAbstractComponent } from '@pc/dialog-abstract';
import { ChevronStateIcons } from '@pc/shared';

@Component({
  selector: 'pc-quote-overview-header',
  standalone: true,
  imports: [CommonModule, IconComponent, SeparatorComponent, DialogAbstractComponent],
  templateUrl: './quote-overview-header.component.html',
  styleUrl: './quote-overview-header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [ItemsSummaryCardAnimation, expand]
})
export class QuoteOverviewHeaderComponent {
  public isQuoteOverviewOpened = input.required<boolean>();
  public totalPriceDescription = input.required<string>();
  public yourQuote = input.required<string>();
  public totalPrice = input.required<number>();
  public isMobile = input.required<boolean>();
  public isStandalone = input.required<boolean>();
  public chevronIcons = input.required<ChevronStateIcons>();
  public quoteOverviewStateChange = output();
  public chevronState = computed(() => (this.isQuoteOverviewOpened() ? ChevronState.Rotated : ChevronState.Default));
  public currentChevronState = computed(() => (this.isMobile() ? ChevronState.Default : this.chevronState()));
  public currentChevronIcon = computed(() => (this.isMobile() ? this.chevronIcons().up : this.chevronIcons().down));

  public toggleQuoteOverview(): void {
    this.quoteOverviewStateChange.emit();
  }
}
